import { Link } from 'react-router-dom';
import '../styles/Page.css';

export default function Competitions() {
  return (
    <div className="page-wrapper">
      <Link to="/" className="page-back">\u2190 Back to Home</Link>
      <h1 className="page-title">⚡ Competitions</h1>
      <p className="page-subtitle">Hackathons, coding contests, and challenges I've joined.</p>
      <div className="placeholder-box">
        <div className="icon">⚡</div>
        <p>Content for <strong>Competitions</strong> goes here.</p>
        <p style={{ marginTop: 8, fontSize: '0.8rem' }}>Fill this section with your own information.</p>
      </div>
    </div>
  );
}
